export const toggleModal = (modal, title, submit, open) => ({
  type: 'TOGGLE_MODAL',
  open,
  modal,
  title,
  submit
})
